import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import React, { useState } from "react";
import http from "../services/HttpService";
import {getResetPasswordEndpoint, getSendPasswordResetMailEndpoint} from "../services/AnwenderService";
import { toast } from "react-toastify";
import {useHistory, useLocation} from "react-router-dom";
import routes from "../consts/routes.json";

function PasswordResetView() {
    const history = useHistory();
    const [username, setUsername] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [requestSuccessful, setRequestSuccessful] = useState(false);
    const [linkError, setLinkError] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const location = useLocation();
    const token = new URLSearchParams(location.search).get('token');

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    }

    const submitResetPasswordRequest = () => {
        setIsLoading(true);
        const data = { username };

        http.post(getSendPasswordResetMailEndpoint(), data)
            .then(response => {
                toast.success("Email zum Zurücksetzen des Passworts gesendet.");
                setIsLoading(false);
                setRequestSuccessful(true);
            })
            .catch(error => {
                toast.error(error.response.data);
                setIsLoading(false);
                setRequestSuccessful(false);
            });
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }

    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value);
    }

    const submitPasswordChange = () => {
        if (password === "" || confirmPassword === "") {
            toast.error("Bitte füllen Sie beide Passwortfelder aus.");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Die Passwörter stimmen nicht überein.");
            return;
        }

        setIsLoading(true);
        const data = { password, token };

        http.put(getResetPasswordEndpoint(), data)
            .then(response => {
                toast.success("Passwort erfolgreich geändert.");
                history.push(routes.LOGIN);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.response.data === "Ungültiger Link.") {
                    setLinkError(true);
                    setRequestSuccessful(false);
                } else {
                    toast.error(error.response.data);
                }
                setIsLoading(false);
            });
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            width="400px"
            height="150px"
            justifyContent="space-around"
            alignItems="center"
            margin="auto"
            padding="20px"
        >
            <h1>{token ? 'Neues Passwort festlegen' : 'Passwort zurücksetzen'}</h1>
            {requestSuccessful ?
                <h2>Prüfen Sie bitte Ihre E-Mails. Wir haben Ihnen einen Link zum Zurücksetzen des Passworts gesendet.</h2>
                :
                <>
                    {token ?
                        <>
                            {linkError ?
                                <h2>
                                    Der verwendete Link ist ungültig. Klicken Sie{' '}
                                    <span onClick={() => {
                                            history.push(routes.RESET_PASSWORD);
                                            setLinkError(false);
                                        }} style={{color: 'blue', cursor: 'pointer', textDecoration: 'underline'}}>
                                            hier
                                    </span>,
                                    um einen neuen Link zu generieren.
                                </h2>
                                :
                                <>
                                    <TextField
                                        label="Neues Passwort"
                                        type="password"
                                        variant="outlined"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        fullWidth
                                        style={{marginBottom: "10px"}}
                                    />
                                    <TextField
                                        label="Passwort bestätigen"
                                        type="password"
                                        variant="outlined"
                                        value={confirmPassword}
                                        onChange={handleConfirmPasswordChange}
                                        fullWidth
                                        style={{marginBottom: "10px"}}
                                    />
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={submitPasswordChange}
                                        fullWidth
                                        disabled={isLoading}
                                    >
                                        {isLoading ? <CircularProgress size={24}/> : "Passwort ändern"}
                                    </Button>
                                </>
                            }
                        </>
                        :
                        <>
                            <TextField
                                label="Benutzername"
                                variant="outlined"
                                value={username}
                                onChange={handleUsernameChange}
                                fullWidth
                                style ={{ marginBottom: "10px" }}
                            />
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={submitResetPasswordRequest}
                                fullWidth
                                disabled={isLoading}
                            >
                                {isLoading ? <CircularProgress size={24}/> : "Passwort zurücksetzen"}
                            </Button>
                        </>
                    }
                </>
            }
        </Box>
    );
}

export default PasswordResetView;